module.exports = __webpack_public_path__ + "static/media/cash.3811fee1.svg";